module.exports = __webpack_public_path__ + "static/media/GOV PP - 2020 NOVO PORTI.1684cded.pdf";